import { ResourceConfigurationInterface } from '@cbsinteractive/avia-js';
import { IPromiseResolveGeneric } from 'library/ts/interfaces/IPromiseResolveGeneric';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { AbstractHTML5ResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/abstract/AbstractHTML5ResourceConfigBuilder';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Builder class to create an instance of ResourceConfigurationInterface for playback via CID on HTML5
 */
export class HTML5CIDResourceConfigBuilder extends AbstractHTML5ResourceConfigBuilder {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'HTML5CIDResourceConfigBuilder',
				...argument
			} );
	}

	/**
	 * @description Returns filled resource configuration for playback via CID on HTML5
	 * @returns {Promise<IPromiseResolveGeneric & {resource: IResourceConfig}>}
	 */
	getResult(): Promise<IPromiseResolveGeneric & { resource: ResourceConfigurationInterface }> {
		return new Promise(
			( resolve, reject ) => {

				// get config prefilled with values for HTML5 playback
				super.getResult().then(
					( data ) => {
						let resource: ResourceConfigurationInterface = data?.resource;

						// set values for CID playback
						resource = this.deepMergeResourceFromSmartTagParams( resource );

						resolve( { msg: 'Resource config', resource: resource } );
					}
				).catch(
					( error ) => {
						// HTML5 CID resource config failed, provide minimal fallback for video playback
						this?.logger?.warn( 'HTML5 CID resource config failed, using minimal configuration:', error );

						// Create minimal resource as fallback to ensure CID videos can still play on mobile
						const basicResource = window.avia.createResourceConfig();
						resolve( { msg: 'Resource config (minimal)', resource: basicResource } );
					}
				);
			}
		);
	}
}